import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { OtaUpdateService } from './ota-update.service';

@Component({
  selector: 'fc-ota-splash-screen',
  template: `
    @if (mode() !== 'hidden') {
      <div class="overlay" [class.fading-out]="service.isFadingOut()">
        <img
          class="logo"
          src="assets/img/logos/splash-logo.png"
          alt="Fleet Chaser"
        />
        @if (mode() === 'updating' || mode() === 'restarting') {
          <div class="update-panel">
            <div class="progress-track">
              <div
                class="progress-fill"
                [style.width.%]="service.downloadPercent()"
              ></div>
            </div>
            <span class="update-label">{{ updateLabel() }}</span>
          </div>
        }
      </div>
    }
  `,
  styles: `
    .overlay {
      position: fixed;
      inset: 0;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 32px;
      background: #113345;
      opacity: 1;
      transition: opacity 0.3s ease-out;
    }

    .overlay.fading-out {
      opacity: 0;
    }

    .logo {
      width: min(52vw, 240px);
    }

    .update-panel {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }

    .progress-track {
      width: 200px;
      height: 4px;
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.2);
      overflow: hidden;
    }

    .progress-fill {
      height: 100%;
      border-radius: 2px;
      background: #1a9dd4;
      transition: width 0.2s ease-out;
    }

    .update-label {
      color: rgba(255, 255, 255, 0.8);
      font-size: 13px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtaSplashScreenComponent {
  readonly service = inject(OtaUpdateService);
  readonly mode = this.service.mode;
  readonly updateLabel = computed(() =>
    this.mode() === 'restarting' ? 'Restarting…' : 'Updating Fleet Chaser…',
  );
}
